import React, { createElement, createRef, Component } from 'react';
import PropTypes from 'prop-types';
import focustrap from 'focus-trap';
import isInBrowser from '@insight/toolkit-utils/lib/types/environment/isInBrowser';

export default class FocusTrap extends Component {
  node = createRef();
  previouslyFocusedElement = isInBrowser() ? document.activeElement : null;

  componentDidMount() {
    const { active, createFocusTrap, focusTrapOptions, paused } = this.props;
    const options = {
      ...focusTrapOptions,
      returnFocusOnDeactivate: false,
    };
    this.focusTrap = createFocusTrap(this.node.current, options);
    if (active) this.focusTrap.activate();
    if (paused) this.focusTrap.pause();
  }

  componentDidUpdate(prevProps) {
    const { active, paused } = prevProps;
    if (active && !this.props.active) {
      this.focusTrap.deactivate();
    } else if (!active && this.props.active) {
      this.focusTrap.activate();
    }

    if (paused && !this.props.paused) {
      this.focusTrap.unpause();
    } else if (!paused && this.props.paused) {
      this.focusTrap.pause();
    }
  }

  componentWillUnmount() {
    this.focusTrap.deactivate();
    if (
      this.props.focusTrapOptions.returnFocusOnDeactivate !== false &&
      this.previouslyFocusedElement &&
      this.previouslyFocusedElement.focus
    ) {
      this.previouslyFocusedElement.focus();
    }
  }

  render() {
    const {
      active,
      children,
      createFocusTrap,
      focusTrapOptions,
      paused,
      tag,
      ...rest
    } = this.props;
    const elementProps = {
      ref: this.node,
      ...rest,
    };

    return createElement(tag, elementProps, children);
  }
}

FocusTrap.propTypes = {
  active: PropTypes.bool,
  createFocusTrap: PropTypes.func.isRequired,
  focusTrapOptions: PropTypes.shape({
    clickOutsideDeactivates: PropTypes.bool,
    escapeDeactivates: PropTypes.bool,
    fallbackFocus: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
      PropTypes.func,
    ]),
    initialFocus: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
      PropTypes.func,
    ]),
    onActivate: PropTypes.func,
    onDeactivate: PropTypes.func,
    returnFocusOnDeactivate: PropTypes.bool,
  }),
  paused: PropTypes.bool,
  tag: PropTypes.string,
};

FocusTrap.defaultProps = {
  active: true,
  createFocusTrap: focustrap,
  focusTrapOptions: {},
  paused: false,
  tag: 'div',
};
